module.exports = __webpack_public_path__ + "static/media/health.1e0b4d52.svg";